/**
 * NewBadge - Badge animado que indica funcionalidad nueva
 */

import React from 'react';
import { shouldShowNewBadge, markFeatureVisited } from '@/lib/featureFlags';

export default function NewBadge({ featureId, className = '' }) {
  if (!shouldShowNewBadge(featureId)) {
    return null;
  }
  
  return (
    <span 
      className={`
        inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase
        bg-gradient-to-r from-[#34C759] to-[#30D158] text-black
        animate-pulse shadow-[0_0_10px_rgba(52,199,89,0.5)]
        ${className}
      `}
    >
      Nuevo
    </span>
  );
}

/**
 * Hook para marcar feature como visitada
 */
export function useMarkFeatureVisited(featureId) {
  React.useEffect(() => {
    if (featureId) {
      markFeatureVisited(featureId);
    }
  }, [featureId]);
}
